import { oc } from "@orpc/contract";
import { z } from "zod";
import { Cart } from "./cart";

/**
 * "Bestel opnieuw" from the shipping mail (spec frontend v2, "Bestel opnieuw"; #257). The mail's
 * link is `/bestel-opnieuw?token=…`: a token signed by the Worker, carrying the order number, valid
 * for 180 days. Whoever holds it can put that order's lines in their own cart, a guest as well as a
 * signed-in customer. It gives nothing else: no addresses, no customer, no order details.
 */

export const ReorderInput = z.object({ token: z.string().min(1).max(512) });
export type ReorderInput = z.infer<typeof ReorderInput>;

export const ReorderContract = {
	/**
	 * Puts the order's lines in the visitor's cart (the cart of their cookie or session, or a new
	 * one with a cookie) and answers the cart, with the notices of `accountOrder.reorder`: a variant
	 * no longer for sale is skipped (`variantRemoved`), a quantity is capped at what is available
	 * (`quantityReduced`, 0 for out of stock).
	 *
	 * Errors: `ReorderLinkExpired` (410): the link is older than 180 days; `ReorderLinkInvalid`
	 * (400): not a link this shop made, or its order is gone.
	 */
	reorder: oc.route({ method: "POST", path: "/shop/reorder" }).input(ReorderInput).output(Cart),
};
